
declare global {
    interface Window {
        __RINVOX_NATIVE_APP__?: boolean
        __RINVOX_APP_PLATFORM__?: "ios" | "android"
        __RINVOX_SYSTEM_THEME__?: "light" | "dark"
        __mauiPendingAuth?: any
        __mauiPendingAuthToken?: string
        __mauiPendingAuthDeviceToken?: string
        __mauiPendingAuthUserId?: string

    }
}

export const isNativeApp = (): boolean => {
    return window.__RINVOX_NATIVE_APP__ === true
}

export const isNativeiOSApp = (): boolean => {
    return window.__RINVOX_APP_PLATFORM__ === "ios"
}

export const isNativeAndroidApp = (): boolean => {
    return isNativeApp() && window.__RINVOX_APP_PLATFORM__ === "android"
}

// The OS-level appearance as reported by the native host. Inside a native
// WebView the CSS `prefers-color-scheme` query follows the app's own uiMode
// (which we lock to light), so it can't be trusted for the "system" choice.
// The native layer injects the real device appearance here instead.
export const getNativeSystemTheme = (): "light" | "dark" | null => {
    const v = window.__RINVOX_SYSTEM_THEME__
    return v === "light" || v === "dark" ? v : null
}

// Tell the native host which mode the app resolved to, so it can recolor the
// native chrome (status bar / navigation bar) to match. No-op on the web.
export const notifyNativeThemeMode = (mode: "light" | "dark") => {
    if (!isNativeApp()) return
    try {
        const frame = document.createElement("iframe")
        frame.style.display = "none"
        frame.src = `rinvox://theme?mode=${mode}`;
        (document.body || document.documentElement).appendChild(frame)
        setTimeout(() => frame.remove(), 0)
    } catch { }
}

export const sendAuthToNativeApp = (payload: {
    token?: string
    deviceToken?: string
    userId?: string
}) => {
    window.__mauiPendingAuthToken = payload.token
    window.__mauiPendingAuthDeviceToken = payload.deviceToken
    window.__mauiPendingAuthUserId = payload.userId
    window.location.href = "rinvox://save-auth"
}